import { render } from "./ModalTransporter.vue?vue&type=template&id=19c63d90&scoped=true"
import script from "./ModalTransporter.vue?vue&type=script&lang=js"
export * from "./ModalTransporter.vue?vue&type=script&lang=js"

import "./ModalTransporter.vue?vue&type=style&index=0&id=19c63d90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c63d90"]])

export default __exports__